import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useBaseInfoCache } from "@/api/base-info";
import { PageLayout, Skeleton } from "@/components/ui";
import { widgetDefaultPath } from "@/features/protection-widget/checkout/checkout-activation";

export const Route = createFileRoute("/widget/")({
  component: WidgetIndex,
});

function WidgetIndex() {
  const { t } = useTranslation();
  const info = useBaseInfoCache();
  if (info) return <Navigate to={widgetDefaultPath(info.is_plus)} replace />;

  return (
    <PageLayout heading={t("BlyCareShippingProte")}>
      <s-section>
        <s-stack gap="small-200">
          <Skeleton className="h-4 w-37" />
          <Skeleton className="h-14" />
        </s-stack>
      </s-section>
    </PageLayout>
  );
}
